import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TeamComponent} from './team.component';
import {RouterModule} from '@angular/router';
import {InviteTeammatesDialogComponent} from './dialogs/invite-teammates-dialog/invite-teammates-dialog.component';
import {EditUserDialogComponent} from './dialogs/edit-user-dialog/edit-user-dialog.component';
import {AlertModule} from '../shared/components/alert/alert.module';
import {BadgeModule} from '../shared/components/badge/badge.module';
import {DialogModule} from '../shared/components/dialog/dialog.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputModule} from '../shared/components/input/input.module';
import {DropdownModule} from '../shared/components/dropdown/dropdown.module';
import {SwitcherModule} from '../shared/components/switcher/switcher.module';
import {ButtonModule} from '../shared/components/button/button.module';
import {WarningDialogModule} from '../shared/components/warning-dialog/warning-dialog.module';
import {FormattedDateModule} from '../shared/pipes/formatted-date/formatted-date.module';
import {FormattedDatePipe} from '../shared/pipes/formatted-date/formatted-date.pipe';

const routes = [
  {
    path: '', component: TeamComponent,
    children: [],
  },
];

@NgModule({
  declarations: [
    TeamComponent,
    InviteTeammatesDialogComponent,
    EditUserDialogComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    AlertModule,
    BadgeModule,
    DialogModule,
    ReactiveFormsModule,
    InputModule,
    DropdownModule,
    SwitcherModule,
    FormsModule,
    ButtonModule,
    WarningDialogModule,
    FormattedDateModule,
  ],
  providers: [
    FormattedDatePipe,
  ],
})
export class TeamModule {
}
